import axios from "axios";
import * as Endpoints from "../entities/Endpoints";
// This file is used to create an Axios instance for public API requests
const axiosAdminPublicInstance = axios.create({
  baseURL: Endpoints.ADMIN_PUBLIC_API_ENDPOINT,
});

axiosAdminPublicInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Public API Error:", error.response || error.message);
    return Promise.reject(error.response || error.message);
  }
);

export default axiosAdminPublicInstance;
